<template>
  <OButton
    v-if="isVisible"
    id="pageUpButton"
    variant="default"
    size="sm"
    class="w-11 h-20 fixed bottom-8 rounded-md right-6 u-center bg-[#E2E2E2] hover:bg-gray-200 mt-2.5 z-100"
    :class="[isVisible ? 'scroll-up' : 'hidden']"
    aria-label="sayfa yukarı"
    @click="handlePageUp"
  >
    <OIcon icon="arrow-right" class="text-primary-200 transform -rotate-90" />
  </OButton>
</template>

<script>
import { defineComponent, onMounted, onUnmounted, ref } from '@nuxtjs/composition-api';
import { throttle } from 'lodash';
import { OButton, OIcon } from '~/modules/common/components/ui';

export default defineComponent({
  components: { OButton, OIcon },
  setup() {
    const isVisible = ref(false);
    const getScrollPercent = () => {
      const h = document.documentElement;
      const b = document.body;
      const st = 'scrollTop';
      const sh = 'scrollHeight';
      return ((h[st] || b[st]) / ((h[sh] || b[sh]) - h.clientHeight)) * 100;
    };
    const toggleVisibility = throttle((arr) => {
      isVisible.value = getScrollPercent() > 10;
    }, 100);

    onMounted(() => {
      isVisible.value = getScrollPercent() > 10;
      window.addEventListener('scroll', toggleVisibility);
    });
    onUnmounted(() => {
      window.removeEventListener('scroll', toggleVisibility);
    });

    const handlePageUp = () => {
      window.scrollTo({
        top: 0,
      });
    };
    return { isVisible, handlePageUp };
  },
});
</script>

<style scoped>
.scroll-up {
  animation: fade-in-up 0.25s ease;
}

@keyframes fade-in-up {
  0% {
    transform: translateY(100%);
    opacity: 0;
  }
  100% {
    transform: translateY(0);
    opacity: 1;
  }
}
</style>
